import * as React from 'react';
import { LandingPageAppLayout } from '@components/LandingPageApp/LandingPageAppLayout/LandingPageAppLayout.component';
import { defaultNamespaces } from '@utils/strings';
import { PlcNextPage, PlcNextPageContext } from 'features/business/app.types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const DiscoverPLCApp: PlcNextPage = () => {
  return <LandingPageAppLayout />;
};

export async function getStaticProps({ locale }: PlcNextPageContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'fr', [...defaultNamespaces])),
    },
  };
}

export default DiscoverPLCApp;
